import { SvgIcon, SvgIconProps } from '@mui/material';
import useTheme from '@mui/material/styles/useTheme';

export const IllustrationCheckCircle = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon
      style={{ fill: 'none', ...props.style }}
      data-testid="IllustrationCheckCircle"
      {...props}>
      <path
        d="M49.4815 87.2783C73.2307 87.2783 92.4834 68.0265 92.4834 44.2783C92.4834 20.5301 73.2307 1.27832 49.4815 1.27832C25.7322 1.27832 6.47949 20.5301 6.47949 44.2783C6.47949 68.0265 25.7322 87.2783 49.4815 87.2783Z"
        fill={theme.palette.success['190p']}
        stroke={theme.palette.primary.main}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M43.7803 87.2783C67.5296 87.2783 86.7823 68.0265 86.7823 44.2783C86.7823 20.5301 67.5296 1.27832 43.7803 1.27832C20.0311 1.27832 0.77832 20.5301 0.77832 44.2783C0.77832 68.0265 20.0311 87.2783 43.7803 87.2783Z"
        fill={theme.palette.success['190p']}
        stroke={theme.palette.primary.main}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M29.5166 38.5737L43.1188 60.0758L61.3309 24.0957"
        fill={theme.palette.success['190p']}
      />
      <path
        d="M28.4316 38.5737L41.0921 58.5871C41.5071 59.2432 42.4788 59.1967 42.8294 58.5041L60.246 24.0957"
        stroke={theme.palette.success.main}
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M46.6305 136.722C68.5636 136.722 86.3439 132.593 86.3439 127.5C86.3439 122.407 68.5636 118.278 46.6305 118.278C24.6973 118.278 6.91699 122.407 6.91699 127.5C6.91699 132.593 24.6973 136.722 46.6305 136.722Z"
        fill={theme.palette.primary.main}
      />
    </SvgIcon>
  );
};
